var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgElectricUtility = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.253,
    height: 18,
    viewBox: "0 0 16.253 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.253,5.048h-4.5V0H10.555V5.048H5.7V0H4.5V5.048H0V6.242H1.478V8.617a6.655,6.655,0,0,0,6.051,6.618V18H8.724V15.235a6.655,6.655,0,0,0,6.051-6.618V6.242h1.478ZM13.581,8.617a5.455,5.455,0,1,1-10.909,0V6.242H13.581Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgElectricUtility);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/electric-utility.b760c76172bb0e6ef1020b9520641ed4.svg";